import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConstantesService } from '../../../core/constantes/constantes.service';
import { Observable } from 'rxjs/Observable';
import { Sociedad } from '../../../core/modelos/sociedad';

@Injectable()
export class SociedadesService {

    constructor(private http: HttpClient, private constantes: ConstantesService) { }

    getSociedades(): Observable<any> {
        /* return this.constantes.respuestaSociedadesCacheados ?
            Observable.of(this.constantes.respuestaSociedadesCacheados) :
            this.http.get(environment.urlBase + 'sociedades', this.constantes.httpOptions); */
        return this.http.get(environment.urlBase + 'sociedades', this.constantes.httpOptions);
    }

    getSociedadesDatosBasicos(): Observable<any> {
        return this.http.get(environment.urlBase + 'sociedades', this.constantes.httpOptions);
    }

    getSociedad(id: number): Observable<any> {
        return this.http.get(environment.urlBase + 'sociedades/' + id, this.constantes.httpOptions);
    }

    updateSociedad(sociedad: Sociedad): Observable<any> {
        return this.http.put(environment.urlBase + 'sociedades/' + sociedad.id, sociedad, this.constantes.httpOptions);
    }

    addSociedad(sociedad: Sociedad): Observable<any> {
        return this.http.post<Sociedad>(environment.urlBase + 'sociedades', sociedad, this.constantes.httpOptions);
    }

    deleteSociedad(id: number): Observable<any> {
        return this.http.delete(environment.urlBase + 'sociedades/' + id, this.constantes.httpOptions);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/sociedades/sociedades.service.ts